// extracted by mini-css-extract-plugin
export var readonly = "_e7-1";
export var star = "_e7-0";